export default function CSemicolons() {
  return <h2>C Semicolons</h2>;
}
